import * as React from "react";

function SvgTableau(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 311.7 60.9"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <switch>
        <g>
          <path
            fill="#E8762D"
            d="M40.1 28h-8.3v-9h-3.3v9h-8.2v3.2h8.2v9h3.3v-9h8.3z"
          />
          <path
            fill="#C72037"
            d="M23.4 42.7H16v-8.1h-2.8v8.1H5.8v2.5h7.4v8H16v-8h7.4z"
          />
          <path
            fill="#5B879B"
            d="M54.6 13.9h-7.5V5.8h-2.8v8.1h-7.4v2.4h7.4v8h2.8v-8h7.5z"
          />
          <path
            fill="#5C6692"
            d="M36.5 51.7h-5.1V46H29v5.7h-5v2.1h5v5.7h2.4v-5.7h5.1z"
          />
          <path
            fill="#EB9129"
            d="M23.4 13.9h-7.5V5.8h-2.6v8.1H5.8v2.3h7.5v8.1h2.6v-8.1h7.5z"
          />
          <path
            fill="#5C6692"
            d="M60.3 28.5h-5.1v-5.6h-2.4v5.6h-5v2.2h5v5.6h2.4v-5.6h5.1z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#1F457E"
            d="M54.6 42.7h-7.5v-8.1h-2.8v8.1h-7.4v2.5h7.4v8h2.8v-8h7.5z"
          />
          <path
            fill="#7199A6"
            d="M29.3 0v5.5h-5v1.7h5v5.5h1.8V7.2h5V5.5h-5V0zM11.8 28.7h-5v-5.4H5v5.4H0v1.8l5-.1v5.5h1.8v-5.5h5z"
          />
          <g fillRule="evenodd" clipRule="evenodd">
            <path
              fill="#5B879B"
              d="M87.4 60.4c.6.4 1.3.5 2 .5 1.4 0 2.3-.7 2.3-1.7 0-.6-.2-1.1-.8-1.4-.4-.3-.9-.4-1.4-.6-.5-.2-.8-.4-.8-.6 0-.3.3-.5.8-.5s1.1.2 1.9.6v-1.2c-.7-.3-1.3-.5-1.9-.5-1.3 0-2.2.7-2.2 1.6 0 1 .7 1.5 2.1 2 .5.2.8.3.8.6s-.3.5-.9.5c-.6 0-1.2-.3-1.9-.7v1.4zM115.4 58c0 .8.3 1.6.9 2.1.6.5 1.3.8 2.2.8.9 0 1.6-.3 2.2-.8.6-.6.9-1.3.9-2.1 0-.9-.3-1.6-.9-2.1-.6-.5-1.3-.8-2.2-.8-.9 0-1.6.3-2.2.8-.6.5-.9 1.3-.9 2.1m1.5 0c0-1 .7-1.8 1.6-1.8.9 0 1.6.7 1.6 1.8 0 1-.7 1.7-1.6 1.7-1 0-1.6-.7-1.6-1.7M146.9 60.8h1.4v-2.3h2.1v-1.1h-2.1v-1.2h2.2v-1.1h-3.6zM177.2 60.8h1.5v-4.6h1.8v-1.1h-5.2v1.1h1.9zM205.8 60.9h.6l1.3-3.6 1.3 3.6h.6l2.3-5.8h-1.5l-1.1 3.2-1.1-3.2h-1l-1.1 3.1-1.1-3.1h-1.5zM233.4 60.8h1.5l.5-1.1h2.5l.4 1.1h1.5l-2.2-5.7H236l-2.6 5.7zm2.4-2l.9-2.2.8 2.2h-1.7zM262.9 60.8h1.4v-2.3h.2c.6 0 .8.2 1 .7l.7 1.6h1.6l-.9-2c-.2-.4-.4-.6-.7-.7.7-.3 1-.8 1-1.4 0-1.1-.7-1.7-2.3-1.7h-2.1v5.8zm2.1-3.3h-.7v-1.3h.7c.5 0 .8.2.8.7 0 .4-.3.6-.8.6M291.5 60.8h3.9v-1h-2.5v-1.4h2.3v-1h-2.3v-1.2h2.4v-1.1h-3.8z"
            />
            <path
              fill="#1F457E"
              d="M160.4 25c2-.8 3.7-1 4.8-1 5.6 0 9.3 3.9 9.3 10 0 6.4-4 10.1-10.9 10.1-2.4 0-4.8-.5-7.3-1.3l-.1-28.1h4.2V25zm3.6 15.3c3.9 0 6.1-2.2 6.1-6.2 0-3.9-2.2-6.3-5.7-6.3-1.5 0-3 .5-4 1v10.7c1.2.5 2.4.8 3.6.8M191.8 10.7h4.1v36.9h-4.1zM218.7 31.8h9.5c-.1-2.5-1.5-3.8-3.9-4-2.4-.1-4.8 1.4-5.6 4m4.7 12.4c-6.4-.6-9.4-5.1-9.3-10.4.2-5.7 3.9-9.8 9.5-9.8 5.9 0 9.3 4.4 9.1 10.8h-14.3c.3 3.6 2.5 5.3 5.4 5.5 2.4.2 5.9-.4 7.8-1.5v3.9c-2.4 1.2-5 1.8-8.2 1.5M293.9 40.9c2.6 0 4.4-1.3 4.4-4.3V24.4h4.2v12.7c0 4.3-3.3 6.9-8.6 6.9-5.2 0-8.5-2.6-8.5-6.9V24.4h4.2v12.2c-.1 3 1.7 4.3 4.3 4.3M128.7 44.1c-7 0-10.9-3.7-10.9-10.1 0-6.1 3.8-10 9.3-10 1.9 0 3.4.4 4.8 1.3v-1.4h4.2l-.1 18.9c-1.7.7-4.6 1.3-7.3 1.3m-.4-3.8c.9 0 2.1-.1 3.6-.5l.1-10.7c-1.3-.9-2.6-1.3-4-1.3-3.5 0-5.7 2.3-5.7 6.3-.1 3.9 2.1 6.2 6 6.2M260.4 44.1c-7 0-10.9-3.7-10.9-10.1 0-6.1 3.8-10 9.3-10 1.9 0 3.4.4 4.8 1.3v-1.4h4.2l-.1 18.9c-1.8.7-4.6 1.3-7.3 1.3m-.4-3.8c.8 0 2.1-.1 3.6-.5l.1-10.7c-1.3-.9-2.6-1.3-4-1.3-3.5 0-5.7 2.3-5.7 6.3-.1 3.9 2.1 6.2 6 6.2"
            />
          </g>
          <g fill="#1F457E">
            <path d="M86.8 16h4.1v11.7h11.2v3.8H90.9v12.7h-4.1V31.5H75.7v-3.8h11.1zM309.3 24.2c1.4 0 2.4 1.1 2.4 2.5s-1.1 2.5-2.4 2.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5zm0 .4c-1.1 0-2 .9-2 2.1 0 1.2.9 2.1 2 2.1s2-.9 2-2.1c0-1.2-.9-2.1-2-2.1zm-.5 3.5h-.4v-2.8c.2 0 .5-.1.8-.1.4 0 .7.1.9.2.2.1.3.3.3.6 0 .4-.2.6-.5.7.2 0 .4.3.5.7.1.4.1.6.2.7h-.5c-.1-.1-.1-.3-.2-.7-.1-.4-.2-.5-.6-.5h-.3v1.2zm0-1.5h.3c.4 0 .7-.1.7-.5 0-.2-.2-.5-.7-.5h-.3v1z" />
          </g>
        </g>
      </switch>
    </svg>
  );
}

export default React.forwardRef(SvgTableau);
